import Nullstack from 'nullstack';
export default function IconXboxB({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-xbox-b",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
  }), "   ", Nullstack.element("path", {
    d: "M13 12a2 2 0 1 1 0 4h-3v-4"
  }), "   ", Nullstack.element("path", {
    d: "M13 12h-3"
  }), "   ", Nullstack.element("path", {
    d: "M13 12a2 2 0 1 0 0 -4h-3v4"
  }), " ");
}